(function ($) {
  jQuery(document).ready(function () {  
    $('#subject').change(function() {
      $('option:selected', this).addClass('active').siblings().removeClass('active');
      $(this).parent().addClass('active');
    });
  });
  
  jQuery(document).ready(function() {
     // Initially open the first tab
      $('.ezi-tab-item:first .tab-content').show();
      $('.ezi-tab-item:first .tab-title').addClass('active');
      $('.ezi-tab-item:first .tab-title').parent().parent().addClass('active');
      
      // Handle tab clicks
      $('.tab-title').on('click', function() {
          var $content = $(this).next('.tab-content');
          // Close all open tab contents and remove 'active' class from their titles
          $('.tab-content').not($content).slideUp().prev('.tab-title').removeClass('active').parent().parent().removeClass('active');
          // Toggle the clicked tab's content and 'active' class on its title
          $content.slideToggle();
          $(this).toggleClass('active');
          $(this).parent().parent().toggleClass('active');
      });
  });
})(jQuery);